import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import {Navigate, Route} from 'react-router-dom';
import {makeuproutes} from '../../../../utils/demostoreUtils';

// One explicit route per valid productType: only valid values match, everything else falls through
const ACCESSORIES = ['hat', 'headband'];
const OTHERS = ['eye-wear', 'hair-color'];
const PRODUCT_TYPES = [...makeuproutes, ...ACCESSORIES, ...OTHERS];

export default [
  <Route
    key="/business/showcase/"
    path="business/showcase"
    element={<Navigate to="lip-color" replace />}
  />,
  <Route key="/business/showcase/producttype" element={<ShowocaseLayout />}>
    {PRODUCT_TYPES.map(type => (
      <Route
        key={type}
        path={`business/showcase/${type}`}
        element={<AsyncPage />}
      />
    ))}
  </Route>,
];
